/**
 * Settings Modal Event Handlers
 *
 * Handles settings modal interactions: opening (with population), saving, canceling,
 * first-run modal, and mobile menu integration.
 */

import { closeFirstRunModal } from '../modules/ui';
import { populateSettingsModal } from './settings/populateSettingsModal';
import { saveSettingsFromModal } from './settings/saveSettings';
import { handleFirstRunSubmit } from './settings/firstRun';
import { setupMobileMenuHandlers } from './settings/mobileMenuHandlers';
import type { SettingsHandlerDeps, SettingsElements } from './settings/types';

export type { SettingsHandlerDeps, SettingsElements } from './settings/types';

export function setupSettingsHandlers(deps: SettingsHandlerDeps): void {
  const { els, state } = deps;

  if (els.openOptions) {
    els.openOptions.addEventListener('click', function () {
      populateSettingsModal(deps);
    });
  }

  if (els.saveSettings) {
    els.saveSettings.addEventListener('click', async function () {
      await saveSettingsFromModal(deps);
    });
  }

  if (els.firstRunSkip) {
    els.firstRunSkip.addEventListener('click', function () {
      closeFirstRunModal();
    });
  }

  if (els.firstRunSubmit) {
    els.firstRunSubmit.addEventListener('click', async function () {
      await handleFirstRunSubmit(deps);
    });
  }

  setupMobileMenuHandlers(els);
}
